module.exports = __webpack_public_path__ + "img/9.75601e8e.svg";